import { render, staticRenderFns } from "./WaiterLabelSettingTab.vue?vue&type=template&id=3399c193&scoped=true&lang=pug"
import script from "./WaiterLabelSettingTab.vue?vue&type=script&lang=ts"
export * from "./WaiterLabelSettingTab.vue?vue&type=script&lang=ts"
import style0 from "./WaiterLabelSettingTab.vue?vue&type=style&index=0&id=3399c193&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3399c193",
  null
  
)

export default component.exports